// @flow
import * as React from 'react'
import { Button } from 'sputnik-ui'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { MainTemplate, Countries, StyledButtonsList } from 'components'
import DevicesSearchList from 'components/molecules/DevicesSearchList'
import ExportDeviceModal from 'features/Devices/ExportDeviceModal'
import { getCountries } from 'store/resources/operations'
import { clearResources } from 'store/resources/actions'
import ProfileModal from 'components/organisms/ProfileModal'
import AddThirdPartyCamerasStandAlone from 'features/AddThirdPartyCamerasStandAlone'
import AddThirdPartyDevice from 'features/AddThirdPartyDevice'
import { ExcludeTurkey, IncludeSpecific } from 'utils/helpers'

function HomePage({
  devicesLoading,
  currentOrdersCount,
  userCompanyUuid,
  dataCurrent,
  dispatch,
  user,
  // Тоггл «Новая главная» справа от заголовка (business_apps#1486 §4.1);
  // без него страница ровно такая, как была.
  titleAction,
}) {
  const { t } = useTranslation(['orders', 'common', 'devices'])

  // general

  const [profileModal, setProfileModal] = React.useState(false)
  const [exportDevicesModal, setExportDevicesModal] = React.useState(false)

  const [AddThirdPartyCamerasModal, setAddThirdPartyCamerasModal] =
    React.useState(false)
  const [AddThirdPartyDevicModal, setAddThirdPartyDeviceModal] =
    React.useState(false)

  const dateCalc = (e) => {
    const interval = 200 // day

    if (e?.updated_at) {
      const date1 = dayjs(e.updated_at * 1000)
      const date2 = dayjs()

      const result = date2.diff(date1, 'day')
      if (result >= interval) setProfileModal(true)
    } else {
      setProfileModal(true)
    }
  }

  React.useEffect(() => {
    if (dataCurrent) dateCalc(dataCurrent)
  }, [dataCurrent])

  React.useEffect(() => {
    dispatch(getCountries())

    return () => {
      clearResources()
    }
  }, [currentOrdersCount, dispatch])

  return (
    <>
      <MainTemplate>
        <StyledButtonsList>
          <ExcludeTurkey>
            <Button
              secondary
              rounded
              component={Link}
              to="/orders"
              style={{
                position: 'relative',
              }}
            >
              {t('orders:units.order', { count: 2 })}
            </Button>
          </ExcludeTurkey>
          <Button
            secondary
            rounded
            component={Link}
            to="/add_address"
            style={{
              position: 'relative',
            }}
          >
            {t('devices:actions.install')}
          </Button>
          <Button
            secondary
            rounded
            style={{
              position: 'relative',
            }}
            onClick={() => setProfileModal(true)}
          >
            {t('devices:actions.change_service_data.first_text')}
            <br />
            {t('devices:actions.change_service_data.second_text')}
          </Button>
          <Button
            secondary
            rounded
            component={Link}
            to="/warranty"
            style={{
              position: 'relative',
            }}
          >
            {t('devices:actions.warranty')}
          </Button>
          <IncludeSpecific
            authUser={user}
            allowed={[
              'fadd874c-d976-4710-9502-332e8eb21f26',
              'cd86d4b7-5cf0-441a-ad06-7a326c9bbe40',
              'adeffb47-1707-4976-a4a6-e6eacf19b050',
            ]}
          >
            <Button
              secondary
              rounded
              onClick={() => setAddThirdPartyDeviceModal(true)}
              style={{
                position: 'relative',
              }}
            >
              {t('devices:actions.add_third_party_device')}
            </Button>
          </IncludeSpecific>
          <Button
            secondary
            rounded
            onClick={() => setAddThirdPartyCamerasModal(true)}
            style={{
              position: 'relative',
            }}
          >
            {t('devices:actions.add_third_party_camera')}
          </Button>
        </StyledButtonsList>

        <Countries />
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 18,
              // с тогглом строка переносится, чтобы не сжимать пилюлю экспорта
              flexWrap: titleAction ? 'wrap' : undefined,
            }}
          >
            <Typography variant="h5">{t('devices:my')}</Typography>
            <Button
              secondary
              rounded
              onClick={() => setExportDevicesModal(true)}
            >
              {t('devices:export.button_title')}
            </Button>
            {titleAction && (
              <div style={{ marginLeft: 'auto' }}>{titleAction}</div>
            )}
          </div>
          <DevicesSearchList />
        </div>
      </MainTemplate>
      <ProfileModal
        open={profileModal}
        handleClose={() => setProfileModal(false)}
      />
      <AddThirdPartyDevice
        open={AddThirdPartyDevicModal}
        handleClose={() => setAddThirdPartyDeviceModal(false)}
      />
      <AddThirdPartyCamerasStandAlone
        open={AddThirdPartyCamerasModal}
        handleClose={() => setAddThirdPartyCamerasModal(false)}
      />
      <ExportDeviceModal
        open={exportDevicesModal}
        handleClose={() => setExportDevicesModal(false)}
        defaultEmail={user.email}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  const { devices, auth, orders, partners } = state

  return {
    devicesLoading: devices.loading,
    userCompanyUuid: auth.user.company.uuid,
    currentOrdersCount: orders.count,
    dataCurrent: partners.current,
    user: auth.user,
  }
}

export default connect(mapStateToProps)(withRouter(HomePage))
